export default __webpack_public_path__ + "static/media/SWT0070.34I-42770_-25555_0.045f482b.jpg";